export const svgToPngBase64 = (svgString: string) => {
  return new Promise((res, rej) => {
    var image = new Image();
    let xml = window.btoa(unescape(encodeURIComponent(svgString)));
    image.src = "data:image/svg+xml;base64," + xml;
    let url = "";
    image.onload = function () {
      console.log(image.width, image.height);
      let canvas = document.createElement("canvas");
      canvas.width = image.width * 50;
      canvas.height = image.height * 50;
      let context = canvas.getContext("2d");
      context?.drawImage(image, 0, 0);
      url = canvas.toDataURL("image/png");
      res(url);
    };
  });
};

export const createBlobURL = (image: Blob) => {
  return URL.createObjectURL(image);
};

export const makeBlobFromBase64 = (dataURL: any) => {
  const BASE64_MARKER = ";base64,";
  const parts = dataURL.split(BASE64_MARKER);
  const raw = atob(parts[1]); // window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: "image/png" });
};

export const convertSVGToPNGUrl = async (SVGString: string) => {
  const base64 = await svgToPngBase64(SVGString);
  const pngBlob = makeBlobFromBase64(base64);
  return createBlobURL(pngBlob);
};

export const convertURItoBlob = (dataURI: any) => {
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
};
